import { useEffect, useState } from 'react';
import type { Sessione, UtenteScelto } from '../../lib/sessione';
import {
  dichiaraUtente,
  dimenticaSessione,
  esci,
  utenteDichiarato,
  utentiDisponibili,
} from '../../lib/sessione';

/*  Chi è collegato, in fondo alla barra di navigazione.

    Serve a una cosa sola e va detta: sapere con quale ruolo si sta guardando
    l'applicativo. Metà delle domande su un gestionale — «io questa voce non ce l'ho» —
    si risolvono leggendo il ruolo di chi sta davanti allo schermo, e finché non c'è
    scritto da nessuna parte quella domanda arriva al telefono.

    Con l'identità dichiarata compare anche il selettore delle persone, che è come si
    prova l'applicativo nei panni dell'operaio senza avere quattro browser aperti.
    L'avviso accanto non è decorazione: un applicativo in cui si scegliere chi essere da
    un menu a tendina non deve poter sembrare pronto.
*/
export function BarraSessione({
  sessione,
  onCambiaPassword,
  onUscito,
}: {
  sessione: Sessione;
  onCambiaPassword: () => void;
  onUscito: () => void;
}) {
  const [utenti, setUtenti] = useState<UtenteScelto[]>([]);

  useEffect(() => {
    if (!sessione.identitaProvvisoria) return;

    /*  L'elenco esiste solo nel modo «Sviluppo»: fuori, la rotta non è nemmeno mappata e
        la chiamata torna 404. Non è un errore da mostrare — è la risposta giusta — quindi
        si resta senza selettore e si mostra solo il nome.  */
    void utentiDisponibili()
      .then(setUtenti)
      .catch(() => setUtenti([]));
  }, [sessione.identitaProvvisoria]);

  if (!sessione.autenticato) return null;

  const scelto = utenteDichiarato() ?? sessione.codice ?? '';

  return (
    <div className="sessione">
      {sessione.identitaProvvisoria && utenti.length > 0 ? (
        <label className="impersona">
          <span className="etichetta">Sei</span>
          <select
            value={scelto}
            onChange={(evento) => {
              dichiaraUtente(evento.target.value);
              /*  Ricaricare invece di rileggere la sessione: cambiare persona cambia
                  cosa si può vedere, e ogni schermata ha già dentro i dati di prima.
                  Ricostruire tutto è l'unico modo semplice di non lasciarne una indietro.  */
              window.location.reload();
            }}
          >
            {utenti.map((u) => (
              <option key={u.id} value={u.codice}>
                {u.nomeCompleto} — {u.ruolo}
              </option>
            ))}
          </select>
        </label>
      ) : (
        <span className="chi">
          {sessione.nomeCompleto} <em>{sessione.ruolo}</em>
        </span>
      )}

      {sessione.identitaProvvisoria && (
        <span className="avviso" title="L'identità la dichiara il chiamante: vale solo in sviluppo.">
          identità di sviluppo
        </span>
      )}

      {/*  La propria password si cambia da qui, in tutti i modi: anche in sviluppo, dove
           non serve a entrare, perché è così che si prova la schermata.  */}
      <button type="button" className="chiave" onClick={onCambiaPassword}>
        Password
      </button>

      {/*  L'uscita c'è solo dove si entra: con l'identità dichiarata non chiuderebbe
           niente — la richiesta successiva tornerebbe collegata — e un bottone che non fa
           quello che dice è peggio di un bottone che manca.  */}
      {sessione.servePassword && (
        <button
          type="button"
          className="esci"
          onClick={() => {
            /*  La copia locale si butta per prima: se la rete cade proprio adesso, la
                richiesta d'uscita può fallire e il cookie restare — ma l'applicativo non
                deve ripartire mostrando i dati di chi stava uscendo.  */
            dimenticaSessione();
            void esci().finally(onUscito);
          }}
        >
          Esci
        </button>
      )}
    </div>
  );
}
